//번역은 안되지만 검색 가능

import React, { useEffect } from "react";
import { Select } from "antd";
import CustomSelectBox from "@components/input/CustomSelectBox";
import styled from "@emotion/styled";
import { Global, css } from "@emotion/react";
import { useApiRequest } from "@utils/ApiRequest";
import { useQuery } from "@tanstack/react-query";
import { useFormContext } from "react-hook-form";

const { Option } = Select;

interface CountrySelectBoxProps {
  onCountryChange: () => void;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
}

export default function CountrySelectBox({
  onCountryChange,
  value,
  onChange,
  error,
}: CountrySelectBoxProps) {
  const { setValue } = useFormContext();
  const { getCountry } = useApiRequest();
  const lang = window.localStorage.getItem("language");

  const { data: countryList } = useQuery({
    queryKey: ["countryList"],
    queryFn: getCountry,
  });

  // 코드에 해당하는 국가 이름을 찾기
  const selectedCountry = countryList?.find((item: any) => item.code === value);
  const selectedCountryName = selectedCountry
    ? lang === "en"
      ? selectedCountry.name_en
      : selectedCountry.name_ko
    : "";

  return (
    <>
      <Global styles={globalStyles} />
      <SelectWrapper error={error}>
        <CustomSelectBox
          placeholder="국가 선택"
          value={selectedCountryName} // 코드에 매핑된 국가 이름 표시
          onChange={(selectedValue, option: any) => {
            setValue("country_name", selectedValue);
            setValue("country", option?.key);
            onChange(option?.key); // 선택한 국가 코드 전달

            onCountryChange();
          }}
          optionFilterProp="children"
          showSearch
          style={{ width: "100%" }}
          className={error ? "country-select-error" : ""}>
          {countryList?.map((item: any) => (
            <Option
              key={item?.code}
              value={lang === "en" ? item.name_en : item.name_ko}>
              {lang === "en" ? item.name_en : item.name_ko}
            </Option>
          ))}
        </CustomSelectBox>
      </SelectWrapper>
    </>
  );
}

const globalStyles = css({
  ".country-select-error:where(.css-dev-only-do-not-override-qnu6hi).ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector":
    {
      borderColor: "#ff4808 !important",
    },

  ".ant-select-show-search:where(.css-dev-only-do-not-override-qnu6hi).ant-select:not(.ant-select-customize-input) .ant-select-selector":
    {
      cursor: "pointer !important",
    },
});

const SelectWrapper = styled.div<{ error?: boolean }>`
  width: 100%;
`;
